// import React, { useEffect, useState } from "react";
// import Swal from "sweetalert2";
// // import { FiMoreVertical } from "react-icons/fi";
// import api from "../../../../../api/axios";
// import { MoreVertical } from "lucide-react";

// export default function AssignRoom() {
//   const [rooms, setRooms] = useState([]);
//   const [filter, setFilter] = useState("dirty");
//   const [users, setUsers] = useState([]);
//   const [openMenuId, setOpenMenuId] = useState(null);

//   const fetchRooms = async () => {
//     const res = await api.get("/pms/rooms");
//     setRooms(res.data.data);
//   };

//   const fetchUsers = async () => {
//     const res = await api.get("/users");
//     setUsers(res.data);
//   };

//   useEffect(() => {
//     fetchRooms();
//     fetchUsers();
//   }, []);

//   const filteredRooms =
//     filter === "all"
//       ? rooms
//       : rooms.filter((r) => r.status.toLowerCase() === filter);

//   const assignToUser = (room) => {
//     setOpenMenuId(null);

//     Swal.fire({
//       title: `Assign Room ${room.number}`,
//       input: "select",
//       inputOptions: users.reduce((acc, u) => {
//         acc[u.id] = u.name;
//         return acc;
//       }, {}),
//       inputPlaceholder: "Select user",
//       showCancelButton: true,
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         await api.post("/pms/assign-room", {
//           room_id: room.id,
//           user_id: result.value,
//         });

//         Swal.fire("Assigned!", "Room assigned successfully", "success");
//         fetchRooms();
//       }
//     });
//   };

//   return (
//     <div className="container py-4">
//       {/* Filter Buttons */}
//       <div className="d-flex gap-2 mb-4">
//         {["all", "dirty", "cleaning", "vacant"].map((s) => (
//           <button
//             key={s}
//             className={`btn ${
//               filter === s ? "btn-dark" : "btn-outline-secondary"
//             }`}
//             onClick={() => setFilter(s)}
//           >
//             {s.toUpperCase()}
//           </button>
//         ))}
//       </div>

//       {/* Cards Grid */}
//       <div className="row g-4">
//         {filteredRooms.map((room) => (
//           <div className="col-md-3" key={room.id}>
//             <div className="card border-0 shadow-sm rounded-4 position-relative room-card">
//               {/* 3-DOT MENU */}
//               <div
//                 className="position-absolute top-0 end-0 p-2"
//                 style={{ cursor: "pointer" }}
//                 onClick={() =>
//                   setOpenMenuId(openMenuId === room.id ? null : room.id)
//                 }
//               >
//                 <MoreVertical size={20} />
//               </div>

//               {openMenuId === room.id && (
//                 <div
//                   className="dropdown-menu show shadow-sm"
//                   style={{
//                     position: "absolute",
//                     top: "40px",
//                     right: "10px",
//                     borderRadius: "10px",
//                   }}
//                 >
//                   <button
//                     className="dropdown-item"
//                     onClick={() => assignToUser(room)}
//                   >
//                     Assign to User
//                   </button>
//                 </div>
//               )}

//               <div className="card-body">
//                 <div className="d-flex justify-content-between">
//                   <h5 className="fw-bold">Room {room.room_number}</h5>
//                   <span className="text-muted fw-semibold">{room.status}</span>
//                 </div>

//                 <div className="text-secondary">{room.type}</div>

//                 <hr />

//                 <p className="mb-1 fw-semibold">Last Cleaned:</p>
//                 <p className="text-muted small mb-3">
//                   {room.last_cleaned_at || "Not cleaned yet"}
//                 </p>

//                 <button className="btn btn-secondary w-100" disabled>
//                   Not Eligible
//                 </button>
//               </div>
//             </div>
//           </div>
//         ))}

//         {filteredRooms.length === 0 && (
//           <p className="text-muted">No rooms found.</p>
//         )}
//       </div>

//       <style>{`
//         .room-card {
//           transition: all 0.2s ease;
//         }
//         .room-card:hover {
//           transform: translateY(-3px);
//           box-shadow: 0 6px 18px rgba(0,0,0,0.1);
//         }
//       `}</style>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import api from "../../../../../api/axios";
import "bootstrap/dist/css/bootstrap.min.css";

const statusColors = {
  dirty: "bg-danger",
  dirty_assigned: "bg-primary",
  cleaning: "bg-info text-dark",
  inspected: "bg-success",
  vacant: "bg-success",
  occupied: "bg-warning text-dark",
  reserved: "bg-secondary",
  maintenance: "bg-dark text-white",
};

const HousekeepingStatus = () => {
  const [rooms, setRooms] = useState([]);
  const [logs, setLogs] = useState([]);
  const [staff, setStaff] = useState([]);

  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedUser, setSelectedUser] = useState("");
  const [showModal, setShowModal] = useState(false);

  // 🔄 Loading states for buttons
  const [assignLoading, setAssignLoading] = useState(false);
  const [startLoading, setStartLoading] = useState(null);
  const [completeLoading, setCompleteLoading] = useState(null);

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = async () => {
    try {
      const roomRes = await api.get("/pms/rooms");
      const logRes = await api.get("/pms/housekeeping");
      const roleRes = await api.get("/roles");
      const userRes = await api.get("/users");

      const hkRole = roleRes.data.data.find((r) =>
        r.name.toLowerCase().includes("house")
      );

      setRooms(roomRes.data);
      setLogs(logRes.data);
      setStaff(userRes.data.data.filter((u) => u.role_id === hkRole?.id));
    } catch (err) {
      console.log(err);
    }
  };

  // Get latest housekeeping log for assigned user
  const getLastLog = (roomId) =>
    logs
      .filter((l) => l.room_id === roomId)
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

  // 1️⃣ ASSIGN CLEANER
  const assignCleaner = async () => {
    if (!selectedUser) return alert("Select cleaner!");
    setAssignLoading(true);

    try {
      await api.post("/pms/housekeeping/status", {
        room_id: selectedRoom.id,
        status: "dirty",
        assigned_to_user_id: selectedUser,
        remarks: "Cleaner assigned",
      });

      setShowModal(false);
      await loadAll();
    } catch (err) {
      console.log(err);
    }

    setAssignLoading(false);
  };

  // 2️⃣ START CLEANING
  const startCleaning = async (room) => {
    const latest = getLastLog(room.id);
    const userId = latest?.assigned_to_user_id;

    setStartLoading(room.id);

    try {
      await api.post("/pms/housekeeping/status", {
        room_id: room.id,
        status: "cleaning",
        assigned_to_user_id: userId,
        remarks: "Cleaning started",
      });

      await loadAll();
    } catch (err) {
      console.log(err);
    }

    setStartLoading(null);
  };

  // 3️⃣ COMPLETE CLEANING
  const completeCleaning = async (room) => {
    const latest = getLastLog(room.id);
    const userId = latest?.assigned_to_user_id;

    setCompleteLoading(room.id);

    try {
      await api.post("/pms/housekeeping/status", {
        room_id: room.id,
        status: "inspected",
        assigned_to_user_id: userId,
        remarks: "Cleaning completed",
      });

      await loadAll();
    } catch (err) {
      console.log(err);
    }

    setCompleteLoading(null);
  };

  return (
    <div className="container-fluid py-3">
      <h3 className="fw-bold mb-4">🧹 Housekeeping Dashboard</h3>

      <div className="row g-4">
        {rooms.map((room) => {
          const latest = getLastLog(room.id);
          const assignedName = latest?.assigned_to_user?.name || null;
          const assignedTime = latest?.created_at?.slice(0, 16) || null;

          return (
            <div className="col-md-4" key={room.id}>
              <div className="card shadow-sm border-0 rounded-4 p-3 position-relative">
                {/* STATUS BADGE */}
                <span
                  className={`position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill ${
                    statusColors[room.housekeeping_status]
                  }`}
                >
                  {room.housekeeping_status.toUpperCase()}
                </span>

                {/* HEADER */}
                <h4 className="fw-bold">
                  <i className="bi bi-door-open text-primary me-2"></i>
                  Room {room.room_number}
                </h4>
                <p className="text-muted">{room.room_type?.name}</p>

                {/* ASSIGNED USER */}
                {assignedName && (
                  <div className="alert alert-secondary py-2 rounded-3">
                    <strong>Assigned to:</strong> {assignedName}
                    <br />
                    <small>
                      <i className="bi bi-clock me-1"></i>
                      {assignedTime}
                    </small>
                  </div>
                )}

                <hr />

                {/* ================= BUTTON LOGIC ================= */}

                {/* DIRTY → Assign Cleaner */}
                {room.status === "dirty" && (
                  <button
                    className="btn btn-primary rounded-pill w-100"
                    onClick={() => {
                      setSelectedRoom(room);
                      setSelectedUser("");
                      setShowModal(true);
                    }}
                    disabled={assignLoading}
                  >
                    {assignLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Assigning...
                      </>
                    ) : (
                      "Assign Cleaner"
                    )}
                  </button>
                )}

                {/* DIRTY_ASSIGNED → Start Cleaning */}
                {room.housekeeping_status === "dirty_assigned" && (
                  <button
                    className="btn btn-info rounded-pill w-100"
                    onClick={() => startCleaning(room)}
                    disabled={startLoading === room.id}
                  >
                    {startLoading === room.id ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Starting...
                      </>
                    ) : (
                      "Start Cleaning"
                    )}
                  </button>
                )}

                {/* CLEANING → Complete Cleaning */}
                {room.housekeeping_status === "cleaning" && (
                  <button
                    className="btn btn-success rounded-pill w-100"
                    onClick={() => completeCleaning(room)}
                    disabled={completeLoading === room.id}
                  >
                    {completeLoading === room.id ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Finishing...
                      </>
                    ) : (
                      "Complete Cleaning"
                    )}
                  </button>
                )}

                {/* INSPECTED / VACANT */}
                {(room.housekeeping_status === "inspected" || room.housekeeping_status === "vacant") && (
                  <div className="alert alert-success text-center rounded-pill">
                    Room Ready
                  </div>
                )}

                {/* OCCUPIED */}
                {room.status === "occupied" && (
                  <div className="alert alert-warning text-center rounded-pill">
                    Guest In Room — No Cleaning
                  </div>
                )}

                {/* RESERVED */}
                {room.status === "reserved" && (
                  <div className="alert alert-secondary text-center rounded-pill">
                    Reserved — No Cleaning Needed
                  </div>
                )}

                {/* MAINTENANCE */}
                {room.status === "maintenance" && (
                  <div className="alert alert-dark text-center rounded-pill text-white">
                    Under Maintenance
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* ASSIGN CLEANER MODAL */}
      {showModal && (
        <div
          className="modal fade show d-block"
          style={{ background: "#00000066" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content rounded-4 p-4">
              <h5 className="fw-bold mb-3">
                Assign Cleaner — Room {selectedRoom.room_number}
              </h5>

              <select
                className="form-select rounded-pill mb-3"
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
              >
                <option value="">Select Housekeeper</option>
                {staff.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.name}
                  </option>
                ))}
              </select>

              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-light rounded-pill"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary rounded-pill"
                  onClick={assignCleaner}
                  disabled={assignLoading}
                >
                  {assignLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Assigning...
                    </>
                  ) : (
                    "Assign"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HousekeepingStatus;
